<template>
  <div>
    <div class="pr-4 pl-3 translation-wrapper ml-4" v-if="isVisible">
      <p v-if="title && !descriptionOnly" class="font-weight-bold mb-0">{{ title }}</p>
      <p v-if="description" class="mb-0">{{ description }}</p>
    </div>
    <div class="d-flex justify-content-end px-3">
      <b-link
        v-if="!isVisible"
        class="btn text-primary text-small font-weight-bold mb-0"
        @click="showTranslation"
      >
        {{ showButtonLabel }}
      </b-link>
      <b-link
        v-else
        class="btn text-primary text-small font-weight-bold mb-0"
        @click="hideTranslation"
      >
        {{ hideButtonLabel }}
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostTranslation",
  props: {
    descriptionOnly: Boolean,
    postId: Number,
    title: String,
    description: String,
    showButtonLabel: String,
    hideButtonLabel: String,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    toggleContent() {
      this.isVisible = !this.isVisible;
    },
    showTranslation() {
      if (!this.title.length) {
        this.$emit("getPostTranslation");
      }
      this.toggleContent();
      trackEvent("showPostTranslation", postId);
    },
    hideTranslation() {
      this.toggleContent();
    },
  },
};
</script>

<style scoped lang="scss">
.translation-wrapper {
  border-left: 0.5rem solid $color-light;
}

.btn:focus,
.btn.focus {
  box-shadow: none;
}
</style>
